import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dc8a282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "About Me", -1))
const _hoisted_3 = {
  key: 0,
  class: "about-item"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hobbies and Interests:", -1))
const _hoisted_5 = { class: "about-interests" }
const _hoisted_6 = {
  key: 1,
  class: "about-item"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Goals:", -1))
const _hoisted_8 = { class: "about-interests" }
const _hoisted_9 = {
  key: 2,
  class: "about-item"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My why for software:", -1))
const _hoisted_11 = { class: "about-interests" }

import { useStore } from 'vuex'
import { computed, onBeforeMount } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutSection',
  setup(__props) {

const store = useStore()
const info = computed(() => store.getters['about/getAboutInformation'])
onBeforeMount(() => store.dispatch('about/getAboutInformation'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (info.value?.interests)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(info.value.interests), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (info.value?.goals)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(info.value.goals), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (info.value?.why)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", null, _toDisplayString(info.value.why), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})